import { render, staticRenderFns } from "./CreateDrawer.vue?vue&type=template&id=aaebe48a"
import script from "./CreateDrawer.vue?vue&type=script&lang=js"
export * from "./CreateDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports